import gql from 'graphql-tag';

export const sanityDocumentFieldsFragment = gql`
  fragment AdminSanityDocumentFields on SanityDocument {
    _id,
    _createdAt,
    _updatedAt,
    _type,
    _rev
  }
`;